import _ from 'lodash';

import {
  selectCurrentTabName,
  makeSelectCurrentRouteInTab,
} from '../Nav/AppTabs/selectors';
import { backToPreviousRoute } from '../Nav/AppTabs/dispatchers';
import {
  ACTIVITY_FEED,
  POST_DETAILS,
  COURSE_LANDING,
  UNREAD_NOTIFICATION_SCREEN,
  ACTIVITY_FEED_SCREEN,
  MISCELLANEOUS_SCREEN,
} from '../routeActions';
import {
  NOTIFICATION_TAB,
  FEED_TAB,
  COURSE_TAB,
  MISC_TAB,
} from '../../native/containers/AppTabs/constants';
import { SET_BOTTOM_TAB_VISIBLE, SET_BOTTOM_TAB_INVISIBLE } from './actions';

export const goBackOrResetStack = () => {
  return (dispatch, getState) => {
    const currentTabName = selectCurrentTabName(getState());
    let backAction = null;
    switch (currentTabName) {
      case NOTIFICATION_TAB:
        backAction = UNREAD_NOTIFICATION_SCREEN;
        break;
      case FEED_TAB:
        backAction = ACTIVITY_FEED_SCREEN;
        break;
      case COURSE_TAB: {
        return dispatch(backToPreviousRoute(currentTabName));
      }
      case MISC_TAB: {
        backAction = MISCELLANEOUS_SCREEN;
        break;
      }
      default:
        break;
    }
    if (backAction) {
      dispatch({
        type: backAction,
        meta: {
          resetStack: true,
        },
      });
    }
    return null;
  };
};

export const setParamsInCurrentLocation = (tabName, query) => (
  dispatch,
  getState
) => {
  const currentLocation = makeSelectCurrentRouteInTab(tabName)(getState());
  let mergeQuery = query;
  if (_.has(currentLocation, 'query')) {
    mergeQuery = Object.assign({}, mergeQuery, currentLocation.query);
  }
  dispatch({
    type: currentLocation.type,
    query: mergeQuery,
    meta: {
      direction: 'replace',
    },
  });
};

export const setBottomTabVisible = (status) => (dispatch) => {
  if (status === 'shown') {
    dispatch({ type: SET_BOTTOM_TAB_VISIBLE });
  } else {
    dispatch({ type: SET_BOTTOM_TAB_INVISIBLE });
  }
};

// RFR-TODO: to be removed
export const navigateToActivityFeed = (coursePath) => ({
  type: ACTIVITY_FEED,
  params: {
    coursePath,
  },
});

export const navigateToPostDetails = (coursePath) => ({
  type: POST_DETAILS,
  params: {
    coursePath,
  },
});

export const navigateToCourseLanding = (coursePath) => ({
  type: COURSE_LANDING,
  params: {
    coursePath,
  },
});
